// Library Methods
import React, { useEffect, useMemo } from "react";

// Components
import { Box, Grid, Typography } from "@mui/material";

// Utils
import { getDecimalNum } from "../../../utils/numberHelper";

const RAPDPupils = ({ chartData }) => {
  // get the latest data added to the pupil events array
  const currentPupilData = useMemo(() => {
    const pupilDataLength = chartData?.pupilEventData?.length;
    return chartData?.pupilEventData?.[pupilDataLength - 1];
  }, [chartData?.pupilEventData]);

  // every time new pupil data is added, update the displayed pupil sizes
  // min pupil size is 30px (3mm) and max pupil size is 90px (9mm)
  useEffect(() => {
    const leftSize = getDecimalNum(currentPupilData?.pupilDiameterLeft, 1) * 10;
    const rightSize =
      getDecimalNum(currentPupilData?.pupilDiameterRight, 1) * 10;

    const leftPupil = document.getElementById("left-pupil");
    leftPupil.style.width = `${leftSize}px`;
    leftPupil.style.height = `${leftSize}px`;

    const rightPupil = document.getElementById("right-pupil");
    rightPupil.style.width = `${rightSize}px`;
    rightPupil.style.height = `${rightSize}px`;
  }, [currentPupilData]);

  return (
    <Grid container justifyContent="center" gap="50px">
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          gap: "8px",
          alignItems: "center",
        }}
      >
        <Box
          id="left-iris"
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            width: "100px",
            height: "100px",
            borderRadius: "50%",
            backgroundColor: "#FF000070",
            transition: "width 0.5s ease, height 0.5s ease",
          }}
        >
          <Box
            id="left-pupil"
            sx={{
              width: "30px",
              height: "30px",
              borderRadius: "50%",
              backgroundColor: "black",
              transition: "width 0.5s ease, height 0.5s ease",
            }}
          />
        </Box>
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
          }}
        >
          {currentPupilData?.brightnessDBLeft && (
            <Typography>{currentPupilData?.brightnessDBLeft} dB</Typography>
          )}
          {currentPupilData?.pupilDiameterLeft && (
            <Typography>
              {getDecimalNum(currentPupilData?.pupilDiameterLeft, 1)} mm
            </Typography>
          )}
        </Box>
      </Box>

      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          gap: "8px",
          alignItems: "center",
        }}
      >
        <Box
          id="right-iris"
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            width: "100px",
            height: "100px",
            borderRadius: "50%",
            backgroundColor: "#0000FF70",
            transition: "width 0.5s ease, height 0.5s ease",
          }}
        >
          <Box
            id="right-pupil"
            sx={{
              width: "30px",
              height: "30px",
              borderRadius: "50%",
              backgroundColor: "black",
              transition: "width 0.5s ease, height 0.5s ease",
            }}
          />
        </Box>
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
          }}
        >
          {currentPupilData?.brightnessDBRight && (
            <Typography>{currentPupilData?.brightnessDBRight} dB</Typography>
          )}
          {currentPupilData?.pupilDiameterRight && (
            <Typography>
              {getDecimalNum(currentPupilData?.pupilDiameterRight, 1)} mm
            </Typography>
          )}
        </Box>
      </Box>
    </Grid>
  );
};

export default RAPDPupils;
